import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';


export const FormApi = {
  async list({ offset, size, sortBy, all, entityType }) {
    return checkErrors(await fetchApi.api.get('forms', { query: { offset, size, sortBy, all, entityType } }));
  },

  async get({ formId }) {
    return checkErrors(await fetchApi.api.get(`forms/${formId}`));
  },

  async getForms() {
    return checkErrors(await fetchApi.api.get('forms/all'));
  },

  async getByName({ name }) {
    return checkErrors(await fetchApi.api.get(`forms/named/${name}`));
  },

  async getByNameForAnonymous({ name, slug, tenant }) {
    return checkErrors(await fetchApi.api.get(`anon/${tenant}/workflows/${slug}/forms/named/${name}`));
  },

  async update(formId, form) {
    return (await checkErrors(await fetchApi.api.put(`forms/${formId}`,{data: form}))).data;
  },

  async getVersions({ formId }) {
    return checkErrors(await fetchApi.api.get(`forms/${formId}/versions`));
  },

  async getVersion({ formId, version }) {
    return checkErrors(await fetchApi.api.get(`forms/${formId}/versions/${version}`));
  },

  async createDraft(formId, { fromVersion } = {}) {
    return (await checkErrors(await fetchApi.api.post(`forms/${formId}/draft`, {
      query: fromVersion != null ? { fromVersion } : undefined,
    }))).data;
  },

  async deleteDraft(formId) {
    return (await checkErrors(await fetchApi.api.delete(`forms/${formId}/draft`))).data;
  },

  // mode: 'immediate' | 'scheduled'. activationDate (ISO string) is required for 'scheduled'.
  // confirmReplaceScheduled must be true to replace an already-Scheduled version (else the API
  // throws a 409 AppException with code AE-3023, which the caller should catch and re-confirm).
  async publish(formId, { mode, activationDate, confirmReplaceScheduled } = {}) {
    return (await checkErrors(await fetchApi.api.post(`forms/${formId}/publish`, {
      data: { mode, activationDate, confirmReplaceScheduled },
    }))).data;
  },

  async cancelSchedule(formId, version) {
    return (await checkErrors(await fetchApi.api.post(`forms/${formId}/versions/${version}/cancel-schedule`))).data;
  },

  async activateNow(formId, version) {
    return (await checkErrors(await fetchApi.api.post(`forms/${formId}/versions/${version}/activate-now`))).data;
  },
};


export default FormApi;
